import Button, { ButtonProps } from 'react-bootstrap/Button';

type PrimaryButtonProps =
  Omit<
  ButtonProps,
  'bsPrefix' | 'variant'> & {
      mode?: 'dark' | 'light';
  };

const PrimaryButton = ({
    mode,
    ...props
}: PrimaryButtonProps) => <Button variant={mode === 'dark' ? 'primary-dark' : 'primary'} {...props} />;

export default PrimaryButton;
